import React from "react";
import { useNavigate , useSearchParams} from "react-router-dom";
import Header from "./Header";
import ic_car_outline from "../img/ic_select_year.png";

function ShowYear() {

    const [searchParams, setSearchParams] = useSearchParams();
    const makename = searchParams.get('makename');
    const modelname = searchParams.get('modelname');
    console.log("makeName ", makename);
    console.log("modelname ", modelname);


    const navigate = useNavigate()

    const clickedOnModel = (modelyear) => {

        //navigate(`/show_category?makename=${makename}&modelname=${modelname}&modelyear=${modelyear}`)
        navigate(`/show_parts_list?makename=${makename}&modelname=${modelname}&modelyear=${modelyear}&maincategory=all&subcategory=all`)

    }

    return (
        <div className="ShowModel-root-container">

            <div className="Header-wrapper">
                <Header />
            </div>

            <div className="Show-container p-4">
                
                <h6>Select Year</h6>

                <div className="Show-container-inner">

                   
                    <div className="list-item-single" onClick={() => clickedOnModel('2024')}>
                        <img src={ic_car_outline} />
                        <p>2024 </p>
                    </div>
                    <div className="list-item-single" onClick={() => clickedOnModel('2023')}>
                        <img src={ic_car_outline} />
                        <p>2023 </p>
                    </div>
                    
                    <div className="list-item-single" onClick={() => clickedOnModel('2022')}>
                        <img src={ic_car_outline} />
                        <p>2022 </p>
                    </div>

                    <div className="list-item-single" onClick={() => clickedOnModel('2021')}>
                        <img src={ic_car_outline} />
                        <p>2021 </p>
                    </div>
                    
                    <div className="list-item-single"  onClick={() => clickedOnModel('2020')}>
                        <img src={ic_car_outline} />
                        <p>2020 </p>
                    </div>
                </div>

            </div>

        </div>
    )
}

export default ShowYear;